import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router'
import { api, query } from '../api/client'
import type { Mover } from '../api/types'
import { MoversFilters, type MoversFilter } from '../components/movers/MoversFilters'
import { MoversTable } from '../components/movers/MoversTable'

function readFilter(params: URLSearchParams): MoversFilter {
	return {
		platform: params.get('p') ?? 'iphone',
		storefront: params.get('c') ?? 'us',
		genre: params.get('g') ?? '',
		type: params.get('t') ?? '',
		window: (params.get('w') as MoversFilter['window']) ?? '24h',
		kind: (params.get('k') as MoversFilter['kind']) ?? 'gainers',
	}
}

export function MoversScreen() {
	const [params, setParams] = useSearchParams()
	const filter = readFilter(params)
	const movers = useQuery({
		queryKey: ['movers', filter],
		queryFn: () =>
			api.get<Mover[]>(
				`/api/v1/movers${query({ platform: filter.platform, storefront: filter.storefront, genre: filter.genre, type: filter.type, window: filter.window, kind: filter.kind, limit: 100 })}`,
			),
		placeholderData: (prev) => prev,
	})
	function update(next: MoversFilter) {
		setParams(
			{ p: next.platform, c: next.storefront, g: next.genre, t: next.type, w: next.window, k: next.kind },
			{ replace: true },
		)
	}
	return (
		<div className="stack">
			<div className="page-header">
				<div>
					<h1>Movers</h1>
					<p className="muted small" style={{ margin: 0 }}>
						Ranking now versus {filter.window === '24h' ? '24 hours' : '7 days'} ago.
					</p>
				</div>
			</div>
			<MoversFilters value={filter} onChange={update} />
			<div className="card" style={{ padding: 0 }}>
				{movers.isPending && <div className="page-loading">Loading…</div>}
				{movers.data?.length === 0 && (
					<div className="empty">
						No movement yet — this needs rankings from at least {filter.window === '24h' ? 'a day' : 'a week'} ago.
					</div>
				)}
				{movers.data && movers.data.length > 0 && <MoversTable rows={movers.data} kind={filter.kind} />}
			</div>
		</div>
	)
}
